import Vue from 'vue';
import { Upload, DatePicker, TimeSelect, Checkbox, Tag, Input, Button, Select, Option, Popover } from 'element-ui';
import ResourceSvc from '@/services/resource.svc.js';
import { Switch as LSwitch } from '@/components/index';
import store from '@/services/store';

import 'element-ui/lib/theme-chalk/index.css';
import { EventBus } from '@/services/Event.js';
const svc = new ResourceSvc();

Vue.directive('intersection', {
    inserted: function(el, binding) {
        const options = {
            rootMargin: '0px',
            threshold: 0.1 // Adjust this threshold as per your requirement
        };

        const observer = new IntersectionObserver((entries, observer) => {
            if (entries[0].isIntersecting) {
                binding.value();
                observer.unobserve(el);
            }
        }, options);

        observer.observe(el);
    }
});

export default {
    name: 'dashboardProfile',
    props: ['userId'],
    components: {
        [DatePicker.name]: DatePicker, [TimeSelect.name]: TimeSelect, [Tag.name]: Tag, [Input.name]: Input, [Select.name]: Select, [Option.name]: Option, [Upload.name]: Upload, [Button.name]: Button, [Popover.name]: Popover, LSwitch, Upload, Checkbox
    },
    data() {
        return {
            loadedUserId: 0,
            isProcessing: false,
            errorMessage: null,
            isParentalApprovalClicked: false,
            isParentalApprovalVisible: false,
            isParentalApprovalWarningVisible: false,
            isAdditionalDetailsAccordionOpen: false,
            topLevel: 0,
            currentYear: new Date().getFullYear(),
            allData: [{
                details: [{
                    label: '',
                    fieldCode: '',
                    isEditable: false,
                    isFromMainTable: false,
                    isRequired: false,
                    isVisible: false,
                    isVisibleIfNull: false,
                    isFromOtherSourse: false,
                    questionType: 0,
                    questionAnswerType: 0
                }],
                level: 0,
                levelName: '',
                customClasses: ''
            }],
            defaultValueDateJunior: new Date().setTime(new Date(0, 0, 1).setFullYear(new Date().getFullYear() - 18)),
            pickerOptionsJunior: {
                disabledDate(date) {
                    var startOfValidYear = new Date(0, 0, 0).setFullYear(new Date(new Date().getFullYear(), 0, 0).getFullYear() - 18) + 24 * 60 * 60 * 1000;
                    return date < startOfValidYear || date > new Date().setFullYear(new Date().getFullYear() - 1);
                },
                shortcuts: []
            }
        };
    },
    computed: {
        isRegistrationCompleted() {
            var preloadedUser = store.getters.getUserShortInfo;

            if (preloadedUser) {
                var value = preloadedUser.details.isRegistrationCompleted;
                return value;
            }
            return true;
        }
    },
    methods: {
        getClassesNamesByLevel(level, isFullWidth) {
            if (isFullWidth) {
                return "col-12";
            }

            var result = 'col-xl-4 col-lg-6 col-md-6 col-sm-12';
            switch (level) {
                case 1:
                case 4:
                    result = 'col-xl-3 col-lg-4 col-md-6 col-sm-6';
                    break;
            }
            return result;
        },
        getLevelNameByLevel(level) {
            var result = 'Other details';
            switch (level) {
                case 1: result = 'Main details'; break;
                case 2: result = 'Location details'; break;
                case 3: result = 'Postal details'; break;
                case 4: result = 'Emergency details'; break;
                case 5: result = 'Marketing Communication'; break;
                default: result = 'Additional details'; break;
            }
            return result;
        },
        isEmptyOrSpaces(str) {
            return !str || String(str).match(/^ *$/) !== null;
        },
        checkRuleSelect(fieldCode, value) {
            var ireland = 'Ireland';
            switch (fieldCode) {
                case 'T_CurrentCountryOfResidence':
                    this.changeVisibilityFieldByFieldCode('T_County', value === ireland);
                    this.changeVisibilityFieldByFieldCode('T_CountyOutsideIreland', value !== ireland);
                    break;
                case 'T_Postal_CurrentCountryOfResidence':
                    this.changeVisibilityFieldByFieldCode('T_Postal_CountyOutsideIreland', value !== ireland);
                    this.changeVisibilityFieldByFieldCode('T_Postal_County', value === ireland);
                    break;
            }
        },
        checkRuleSwitch(fieldCode, isChecked) {
            switch (fieldCode) {
                case 'T_PostalAddressTheSame':
                    if (isChecked) {
                        this.changeVisibilityFieldByFieldCode('T_Postal_County', false);
                        this.changeVisibilityFieldByFieldCode('T_Postal_CountyOutsideIreland', false);
                    }

                    this.changeVisibilityFieldByFieldCode('T_Postal_CurrentCountryOfResidence', !isChecked);
                    this.changeVisibilityFieldByFieldCode('T_Postal_AddressLine1', !isChecked);
                    this.changeVisibilityFieldByFieldCode('T_Postal_AddressLine2', !isChecked);
                    this.changeVisibilityFieldByFieldCode('T_Postal_AddressLine3', !isChecked);
                    this.changeVisibilityFieldByFieldCode('T_Postal_PostCode', !isChecked);

                    break;
                case 'T_ParatriathleteEligible':
                    this.changeVisibilityFieldByFieldCode('T_ParatriathleteDetails', isChecked);
                    break;
                case 'T_BMWSponsorAgreement':
                    this.changeVisibilityFieldByFieldCode('T_BMWSponsorAgreementDetails', isChecked);
                    break;
            }
        },
        clone(me) {
            return JSON.parse(JSON.stringify(me));
        },
        getItem(fieldCode) {
            var clon = this.clone(this.allData);
            var index1V = 0;
            var index2V = 0;
            clon.forEach((data, index1) => {
                data.details.forEach((field, index2) => {
                    if (field.fieldCode === fieldCode) {
                        index1V = index1;
                        index2V = index2;
                    }
                });
            });
            if (index1V && index2V) {
                return this.allData[index1V].details[index2V];
            }
        },
        changeVisibilityFieldByFieldCode(fieldCode, visibility) {
            this.allData.forEach(data => {
                data.details.forEach(field => {
                    if (field.fieldCode === fieldCode) {
                        field.isVisible = visibility;
                    }
                });
            });
        },
        isValueValidForAnswerType(value, type) {
            switch (type) {
                case 3:
                    return !isNaN(parseFloat(value)) && isFinite(value);
                case 4:
                    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return re.test(String(value).toLowerCase());
                case 5:
                    return this.isValidURL(value);
                default:
                    return true;
            }
        },
        isValidURL(str) {
            try {
                new URL(str);
                return true;
            } catch (_) {
                if (str.indexOf('.') === -1) {
                    return false;
                }
            }

            try {
                new URL('http://' + str);
                return true;
            } catch (_) {
                return false;
            }
        },
        parentalApprovalClick() {
            var self = this;
            self.isParentalApprovalWarningVisible = self.isParentalApprovalClicked;
        },
        isSaveAllowed() {
            var self = this;
            var isValid = true;

            self.allData.forEach(data => {
                data.details.forEach(q => {
                    if (q.isVisible && !q.isReadOnly) {

                        if (q.value && q.value.length > 100 && q.type === 1) {
                            isValid = false;
                            return;
                        }

                        var isRequired = (q.type === 1 || q.type === 3) && q.isRequired;
                        var isChecked = q.type === 4 && q.isChecked;
                        if ((isRequired || isChecked) && self.isEmptyOrSpaces(q.value)) {
                            q.isEmpty = true;
                            isValid = false;
                        }
                        else
                            if (!self.isRequired && !q.value) {
                                return;
                            }
                            else
                                if (!self.isValueValidForAnswerType(q.value, q.typeAnswer)) {
                                    if (!q.isChecked && q.type === 4) {
                                        return;
                                    }
                                    q.isNotCorrectFormat = true;
                                    isValid = false;
                                }
                    }
                });
            });

            self.isParentalApprovalWarningVisible = self.userId == -1 && !self.isParentalApprovalClicked;

            if (self.isParentalApprovalVisible) {
                return !self.isParentalApprovalWarningVisible && isValid;
            }

            return isValid;
        },
        getData() {
            var self = this;
            self.isProcessing = true;

            if (self.userId < -2) {
                return;
            }

            if (self.userId && (self.loadedUserId < -2 || self.loadedUserId == 0)) {
                self.loadedUserId = self.userId;
            }

            if (self.userId == -1) {
                self.isParentalApprovalVisible = true;
            }
            else {
                EventBus.$emit("user-load-dashboard-card", self.loadedUserId);
            }

            var data = { userId: self.loadedUserId };
            svc.getProfileInfo(data)
                .then(response => {
                    var allData = response.body;
                    self.isProcessing = false;

                    if (!allData) {
                        self.errorMessage = "Something went wrong!";
                        return;
                    }
                    if (!allData.isSuccess) {
                        self.errorMessage = allData.message;
                        return;
                    }
                    else {
                        self.allData = allData.sortedDetails;
                        self.topLevel = allData.topLevel;
                        self.currentYear = allData.currentYear;
                        self.errorMessage = null;
                        self.initDateFields();
                    }
                    self.$console();
                    self.$console({ ProfileInfo: allData });
                }, response => {
                    self.isProcessing = false;
                    self.errorMessage = "Something went wrong, please contact with dev team!";
                });
        },
        initDateFields(year) {
            if (!year) {
                year = this.currentYear;
            }

            this.defaultValueDateJunior = new Date().setTime(new Date(0, 0, 1).setFullYear(year - 18));
            this.pickerOptionsJunior = {
                disabledDate(date) {
                    var startOfValidYear = new Date(0, 0, 0).setFullYear(new Date(year, 0, 0).getFullYear() - 18) + 24 * 60 * 60 * 1000;
                    return date < startOfValidYear || date > new Date().setFullYear(year - 1);
                },
                shortcuts: [
                    {
                        text: '18 years old',
                        onClick(picker) { const date = new Date(); date.setTime(new Date(0, picker.month, picker.monthDate).setFullYear(year - 18)); picker.$emit('pick', date); }
                    },
                    {
                        text: '17 years old',
                        onClick(picker) { const date = new Date(); date.setTime(new Date(0, picker.month, picker.monthDate).setFullYear(year - 17)); picker.$emit('pick', date); }
                    },
                    {
                        text: '16 years old',
                        onClick(picker) { const date = new Date(); date.setTime(new Date(0, picker.month, picker.monthDate).setFullYear(year - 16)); picker.$emit('pick', date); }
                    },
                    {
                        text: '15 years old',
                        onClick(picker) { const date = new Date(); date.setTime(new Date(0, picker.month, picker.monthDate).setFullYear(year - 15)); picker.$emit('pick', date); }
                    },
                    {
                        text: '14 years old',
                        onClick(picker) { const date = new Date(); date.setTime(new Date(0, picker.month, picker.monthDate).setFullYear(year - 14)); picker.$emit('pick', date); }
                    },
                    {
                        text: '13 years old',
                        onClick(picker) { const date = new Date(); date.setTime(new Date(0, picker.month, picker.monthDate).setFullYear(year - 13)); picker.$emit('pick', date); }
                    },
                    {
                        text: '12 years old',
                        onClick(picker) { const date = new Date(); date.setTime(new Date(0, picker.month, picker.monthDate).setFullYear(year - 12)); picker.$emit('pick', date); }
                    },
                    {
                        text: '11 years old',
                        onClick(picker) { const date = new Date(); date.setTime(new Date(0, picker.month, picker.monthDate).setFullYear(year - 11)); picker.$emit('pick', date); }
                    },
                    {
                        text: '10 years old',
                        onClick(picker) { const date = new Date(); date.setTime(new Date(0, picker.month, picker.monthDate).setFullYear(year - 10)); picker.$emit('pick', date); }
                    },
                    {
                        text: '9 years old',
                        onClick(picker) { const date = new Date(); date.setTime(new Date(0, picker.month, picker.monthDate).setFullYear(year - 9)); picker.$emit('pick', date); }
                    },
                    {
                        text: '8 years old',
                        onClick(picker) { const date = new Date(); date.setTime(new Date(0, picker.month, picker.monthDate).setFullYear(year - 8)); picker.$emit('pick', date); }
                    },
                    {
                        text: '7 years old',
                        onClick(picker) { const date = new Date(); date.setTime(new Date(0, picker.month, picker.monthDate).setFullYear(year - 7)); picker.$emit('pick', date); }
                    },
                    {
                        text: '6 years old',
                        onClick(picker) { const date = new Date(); date.setTime(new Date(0, picker.month, picker.monthDate).setFullYear(year - 6)); picker.$emit('pick', date); }
                    },
                    {
                        text: '5 years old',
                        onClick(picker) { const date = new Date(); date.setTime(new Date(0, picker.month, picker.monthDate).setFullYear(year - 5)); picker.$emit('pick', date); }
                    },
                    {
                        text: '4 years old',
                        onClick(picker) { const date = new Date(); date.setTime(new Date(0, picker.month, picker.monthDate).setFullYear(year - 4)); picker.$emit('pick', date); }
                    },
                    {
                        text: '3 years old',
                        onClick(picker) { const date = new Date(); date.setTime(new Date(0, picker.month, picker.monthDate).setFullYear(year - 3)); picker.$emit('pick', date); }
                    },
                    {
                        text: '2 years old',
                        onClick(picker) { const date = new Date(); date.setTime(new Date(0, picker.month, picker.monthDate).setFullYear(year - 2)); picker.$emit('pick', date); }
                    },
                    {
                        text: '1 year old',
                        onClick(picker) { const date = new Date(); date.setTime(new Date(0, picker.month, picker.monthDate).setFullYear(year - 1)); picker.$emit('pick', date); }
                    }]
            };
        },
        getAllDetailsAsArray() {
            var allDetails = [];
            this.allData.forEach(data => data.details.forEach(detail => allDetails.push(detail)));
            return allDetails;
        },
        saveData() {
            if (!this.isSaveAllowed()) {
                this.$showError("Please fill required fields!");
                return;
            }
            var self = this;
            var data = {
                allDetails: self.getAllDetailsAsArray(),
                userId: self.loadedUserId
            };

            self.isProcessing = true;
            svc.saveProfileInfo(data).then(response => {
                var allData = response.body;

                if (!allData) {
                    self.$showError("Something went wrong!");
                }
                if (!allData.isSuccess) {
                    self.$showError(allData.message);
                }
                else {
                    if (!self.isRegistrationCompleted) {
                        self.getData();
                        EventBus.$emit("load-dashboard-data");
                    }

                    if (self.userId === -1) {
                        store.commit('setCurrentJunior', 'new');
                        EventBus.$emit("load-dashboard-data");

                        self.$showSuccess("New junior account is created. Page will be updated in a moment.");
                        window.scrollTo(0, 0);
                        setTimeout(function () {
                            self.$router.push({ path: '/dashboard/junior/upgrade-membership' });
                        }, 1500);

                        return;
                    }
                    self.$showSuccess("Data successfully saved");
                }
                self.isProcessing = false;
            }, response => {
                self.isProcessing = false;
                self.$showError(null);
            });
        },
        isProfileCompleted() {
            if (!this.isSaveAllowed()) {
                this.$showError("Please fill required fields!");
            }
        }
    },
    created() {
        var self = this;
        self.getData();

        EventBus.$off('user-load-edit-profile');
        EventBus.$on("user-load-edit-profile", (id) => {
            self.loadedUserId = id;
            self.getData();
        });
    }
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/profile/edit-profile/edit-profile.js